module.exports = __webpack_public_path__ + "static/media/user-loan-id.0710035d.svg";